import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Error = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M14.7804 2.57206C15.1467 2.20578 15.6435 2 16.1615 2H33.4115C33.9295 2 34.4262 2.20577 34.7925 2.57206L47.0009 14.7804C47.3671 15.1467 47.5729 15.6435 47.5729 16.1615V33.4115C47.5729 33.9295 47.3671 34.4262 47.0009 34.7925L34.7925 47.0009C34.4262 47.3671 33.9295 47.5729 33.4115 47.5729H16.1615C15.6435 47.5729 15.1467 47.3671 14.7804 47.0009L2.57206 34.7925C2.20577 34.4262 2 33.9295 2 33.4115V16.1615C2 15.6435 2.20578 15.1467 2.57206 14.7804L14.7804 2.57206ZM16.9705 5.90625L5.90625 16.9705V32.6024L16.9705 43.6667H32.6024L43.6667 32.6024V16.9705L32.6024 5.90625H16.9705ZM32.4176 17.1554C33.1803 17.9181 33.1803 19.1548 32.4176 19.9175L27.5486 24.7865L32.4176 29.6554C33.1803 30.4181 33.1803 31.6548 32.4176 32.4175C31.6548 33.1803 30.4182 33.1803 29.6554 32.4175L24.7865 27.5486L19.9176 32.4175C19.1548 33.1803 17.9182 33.1803 17.1554 32.4175C16.3927 31.6548 16.3927 30.4181 17.1554 29.6554L22.0244 24.7865L17.1554 19.9175C16.3927 19.1548 16.3927 17.9181 17.1554 17.1554C17.9182 16.3927 19.1548 16.3927 19.9176 17.1554L24.7865 22.0243L29.6554 17.1554C30.4182 16.3927 31.6548 16.3927 32.4176 17.1554Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
